import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../../reducers/reducer";
import { IAppVariables } from "../../../types/ApiInterfaces";
import OutgoingTransHBLView from "../../../views/DashboardView/SustainabilityView/StorageView/OutgoingTransHBLView";

interface Props {
  app_variables: IAppVariables;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      app_variables: state.settings.app_variables.data,
    }),
    (dispatch: any) => ({
      dispatch,
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(OutgoingTransHBLView);
